export default __webpack_public_path__ + "static/media/blank.67e068b4.jpg";